interface IAvatar {
    name: string;
    size?: number;
    className?: string;
}

function getInitials(name: string): string {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Avatar({ name, size = 40, className = '' }: IAvatar) {
    return (
        <div
            className={'avatar ' + className}
            style={{ width: size, height: size, fontSize: size * 0.38 }}
            aria-hidden="true"
        >
            {getInitials(name)}
        </div>
    );
}
